import angular from 'angular';

import component from './venue-hours-order.component';

const VenueHoursOrder = angular
    .module('control-room.venue-hours.components.venue-hours-order', [])
    .component('crVenueHoursOrder', component);

export default VenueHoursOrder;
